import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, SessionService, LocalStorage } from '@educare/shared';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const sessionService = inject(SessionService);
  const userInfo = authService.getUserInfo();

  if (!!userInfo?.access_token) {
    // Check if profile is completed - required before face verification
    if (!userInfo.user?.is_profile_completed) {
      // If trying to access face-verification without profile completion, redirect to profile completion
      if (state.url.includes('face-verification')) {
        return router.navigate(['auth', 'profile-completion']);
      }
      // If trying to access other routes (except profile-completion), redirect to profile completion
      if (!state.url.includes('profile-completion')) {
        return router.navigate(['auth', 'profile-completion']);
      }
    }

    const faceReg = authService.getFaceRegistration();

    if (state.url.includes('face-verification') && faceReg?.isFaceRecognitionEnabled !== true) {
      return router.navigate(['dashboard']);
    }

    if (state.url.includes('/dashboard') && !state.url.includes('face-verification')) {
      if (faceReg?.isFaceRecognitionEnabled === true) {
        const faceVerified = sessionService.getItem(LocalStorage.FaceVerified);
        if (!faceVerified) {
          return router.navigate(['face-verification']);
        }
      }
    }

    return true;
  }

  return router.navigate(['auth', 'login']);
};
